import {customAxios} from "../../../../utils/customAxios";
import {OrderIdentifier, StateUpdateDto} from "./interfaces";
const axios = customAxios();

export const updateOrderState = (erpState: string, orderIdentifiers: OrderIdentifier[]): Promise<StateUpdateDto> => {
    const payload = {
        query: {},
        body: {
            orderIdentifiers,
            erpState
        }
    }

    return new Promise(resolve => {
        axios.post("/api/Orders/UpdateErpState", payload)
            .then(x => resolve(x.data))
            .catch(err => {
                const errMsg = `Error al actualizar el estado de los pedidos a: ${erpState}`;
                console.log(errMsg);
                console.log(err);
                resolve({
                    error: errMsg,
                    notUpdated: orderIdentifiers.length
                });
            });
    });
}

export const updateOrderItemState = (active: boolean, orderItemId: number): Promise<StateUpdateDto> => {
    const payload = {
        query: {},
        body: {
            orderItemId,
            active
        }
    }

    return new Promise(resolve => {
        axios.post("/api/Orders/UpdateOrderItemState", payload)
            .then(x => resolve(x.data))
            .catch(err => {
                const errMsg = `Error al actualizar el estado de los pedidos a: ${active}`;
                console.log(errMsg);
                console.log(err);
                resolve({
                    error: errMsg,
                    notUpdated: 1
                });
            });
    });
}